<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    undoNum: {
      type: Number,
      default: 0,
    },
  },
  render(h, context) {
    const { icon, title, undoNum } = context.props;
    const vnodes = [];

    if (icon) {
      if (icon.includes('el-icon')) {
        vnodes.push(<i class={[icon, 'sub-el-icon']} />);
      } else {
        vnodes.push(<svg-icon icon-class={icon}/>);
      }
    }

    if (title) {
      if (undoNum) {
        vnodes.push(<span slot='title'>{(title)}<el-badge value={undoNum} max={99} class='feedback-badge' /></span>);
      } else {
        vnodes.push(<span slot='title'>{(title)}</span>);
      }
    }
    return vnodes;
  },
};
</script>

<style scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
}

::v-deep .el-badge {
  top: 2px;
  left: 7px;
}
</style>
